import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Stack } from "@mui/material";

function AccessDeniedPage() { // Define react compnent 
  const navigate = useNavigate(); // give navigate function
  const handleGoHome = () => {
    navigate('/'); // funtion called when "go to homepage" is clicked"
  };
  return (

    <Box>
      <Stack alignItems="center">
        <Typography variant="h4" marginTop={3}>
          Error 403 Forbidden
        </Typography>
        
        <Typography variant="italic" marginBottom={3}>
          You do not have permission to access this page!
        </Typography>

        <Button variant="contained" sx={{maxWidth:"200px"}} onClick={handleGoHome}>
          Return to home
        </Button>
      </Stack>

    </Box>
  );
}
export default AccessDeniedPage;